import type { AvailabilityEntry } from '@fshr/microservices/compiled/booking.v1';
import { ParsedAvailabilities } from '../../types/calendar';
import { parse } from 'date-fns';

type CalendarAvailabilityEntry = {
	date: string;
	status: string;
};

export default function parseAvailability(
	availabilities: CalendarAvailabilityEntry[]
): ParsedAvailabilities {
	const restricted: Date[] = [];
	const unavailable: Date[] = [];
	const notBookable: Date[] = [];
	availabilities.forEach(availability => {
		const parsedDate = parse(availability.date, 'yyyy-MM-dd', new Date());
		const status = availability.status;
		for (let i = 0; i < status.length; i++) {
			const char = status[i];
			const day = i + 1;

			const checkValidDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), day);
			if (checkValidDate.getMonth() !== parsedDate.getMonth()) {
				//skip invalid dates
				continue;
			}

			//0: unavailable / sold out
			//R: restricted / limited
			//.: outside usable availability window (not bookable)
			//1-9: available
			if (char === 'R') {
				restricted.push(checkValidDate);
			} else if (char === '0') {
				unavailable.push(checkValidDate);
			} else if (char === '.') {
				notBookable.push(checkValidDate);
			}
		}
	});

	return {
		restricted,
		unavailable,
		notBookable,
	};
}
